import React from 'react';

const DownloadIcon = ({ className, size }) => {
  return (
    <svg
      className={className}
      width={size || '18'}
      height={size || '18'}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.875 9C1.875 5.64124 1.875 3.96187 2.91843 2.91843C3.96187 1.875 5.64124 1.875 9 1.875C12.3587 1.875 14.0381 1.875 15.0816 2.91843C16.125 3.96187 16.125 5.64124 16.125 9C16.125 12.3587 16.125 14.0381 15.0816 15.0816C14.0381 16.125 12.3587 16.125 9 16.125C5.64124 16.125 3.96187 16.125 2.91843 15.0816C1.875 14.0381 1.875 12.3587 1.875 9Z"
        stroke="#2F3237"
        strokeWidth="1.5"
      />
      <path
        d="M9.00187 5.27881V10.5666M9.00187 10.5666C9.24645 10.5699 9.48772 10.4017 9.6657 10.1966L10.8578 8.85956M9.00187 10.5666C8.76592 10.5634 8.52697 10.3962 8.33805 10.1965L7.13898 8.85956M5.98975 12.7788H11.9897"
        stroke="#2F3237"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default DownloadIcon;
